import {
  Stethoscope, ClipboardList, Users, ShieldCheck, FlaskConical, HeartPulse,
  Baby, Bandage, Armchair, Microscope, Pill, Sparkles, BedDouble, Building2,
  HeartHandshake, GraduationCap, CalendarCheck, MessagesSquare, Droplets,
  Salad, Moon, Clock, MapPin, Phone,
} from "lucide-react";

const ICONS = {
  stethoscope: Stethoscope,
  clipboard: ClipboardList,
  users: Users,
  shield: ShieldCheck,
  flask: FlaskConical,
  heart: HeartPulse,
  baby: Baby,
  bandage: Bandage,
  armchair: Armchair,
  microscope: Microscope,
  pill: Pill,
  sparkles: Sparkles,
  bed: BedDouble,
  building: Building2,
  heartHandshake: HeartHandshake,
  graduationCap: GraduationCap,
  calendarCheck: CalendarCheck,
  messagesSquare: MessagesSquare,
  droplets: Droplets,
  salad: Salad,
  moon: Moon,
  clock: Clock,
  mapPin: MapPin,
  phone: Phone,
};

export const Icon = ({ name, ...props }) => {
  const Cmp = ICONS[name] || Stethoscope;
  return <Cmp {...props} />;
};
